import { FC } from 'react';
import { Link } from 'react-router-dom';
import { IRouteNormalized } from '../../../types';

const NavbarItem: FC<IRouteNormalized> = (props) => {

  const {
    path,
    titleNav,
  } = props;

  return (
    <Link to={path} className="navbar-item">
      {titleNav}
    </Link>
  );

};

export default NavbarItem;
